"use client"
import { useFeatureFlagEnabled } from "posthog-js/react"

export enum FeatureFlag {
  adminHeader = "adminHeader",
  attachDocs = "attachDocs",
  attachEvents = "attachEvents",
  attachFiles = "attachFiles",
  attachIssue = "attachIssue",
  projectSystemPrompt = "projectSystemPrompt",
  chatHistory = "chatHistory",
  chatModelSelect = "chatModelSelect",
  chatShowGenie2Model = "chatShowGenie2Model",
  codeExecution = "codeExecution",
  cosineNEXT = "cosine_NEXT",
  dbMigration = "dbMigration",
  developerAPI = "developerAPI",
  editor = "GENIE_EDITOR",
  legacyAutomations = "legacyAutomations",
  loginWithAzure = "loginWithAzure",
  loginWithPassword = "loginWithPassword",
  onboarding = "onboarding",
  prChecksAndPreviews = "prChecksAndPreviews",
  prettyErrLogsInChat = "prettyErrLogsInChat",
  projectsTemplates = "projectsTemplates",
  promptOptions = "promptOptions",
  showContextWindowDebug = "showContextWindowDebug",
  showOutput = "showOutput",
  showVercel = "showVercel",
  studioUX = "studioUX",
  taskDifficulty = "taskDifficulty",
  taskEdit = "taskEdit",
  taskPause = "taskPause",
  taskRetry = "taskRetry",
  taskStop = "taskStop",
  timelineEdit = "contextEdit",
  uploadImage = "taskUploadImage",
  chatV2 = "CHAT_V2",
  slackIntegration = "slackIntegration",
  benscape = "BENSCAPE",
  vercelPreview = "VERCEL_PREVIEW",
  quickThink = "QUICK-THINK",
}

export const useFeatureFlag = (flag: FeatureFlag) => {
  return useFeatureFlagEnabled(flag.toString())
}

type FlaggedProps = {
  flag: FeatureFlag
  children: React.ReactNode
}

export const FlaggedDisabled = ({ flag, children }: FlaggedProps) =>
  useFeatureFlag(flag) ? null : children

export const Flagged = ({ flag, children }: FlaggedProps) => {
  return useFeatureFlag(flag) ? children : null
}
